/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\service\webaccess\agile.plugins\backlogshub\clientgeneratorconfigs\genclient.json
 */

export interface RollupTimeoutRegistrySettings {
    /**
     * Number of retries to make when trying to retrieve quality data.
     */
    badQualityRetryAttempts: number;
    /**
     * Time to wait between retries in case data in AX is bad quality (i.e. delayed).
     */
    badQualityRetryMs: number;
    /**
     * Time to wait betwen interactive data modifications before attempting to query Analytics.
     */
    debounceTimeGetDataMs: number;
    /**
     * Number of work items to batch together for rollup queries.
     */
    pageSize: number;
}
